// @ts-strict-ignore
import { Component } from "@angular/core";
import { CategorizedComponents } from "src/app/shared/components/edge/edgeconfig";
import { EdgeConfig, Service, Utils } from "../../../../shared/shared";
import { BehaviorSubject, Subscription } from "rxjs";
import { filter } from "rxjs/operators";

interface MyCategorizedComponents extends CategorizedComponents {
  isNatureClicked?: boolean,
  filteredComponents?: EdgeConfig.Component[]
}

@Component({
  selector: IndexComponent.SELECTOR,
  templateUrl: "./index.component.html",
})
export class IndexComponent {

  private static readonly SELECTOR = "indexComponentUpdate";

  public edgeConfig: BehaviorSubject<EdgeConfig> | null = null;
  public config: EdgeConfig | null = null;
  public list: MyCategorizedComponents[] = [];

  public showAllEntries = false;

  protected searchbarValue = "";

  private updateComponentListSubscription: Subscription;

  constructor(
    private service: Service,
  ) {
  }

  public async ionViewWillEnter() {
    // Subscribe to the getConfig() subject to update the component list automatically when the configuration changes.
    const edge = await this.service.getCurrentEdge();
    this.updateComponentListSubscription = edge.getConfig(this.service.websocket)
      .pipe(filter(config => config != null))
      .subscribe(config => {
        this.updateComponentsList(config);
        this.updateFilter(this.searchbarValue);
      });

    this.updateFilter("");
  }

  ionViewDidLeave() {
    // Clear searchbar value when navigation to a new page was successfull. Otherwise the searchbar would show an old value the next time the page is entered.
    // To prevent the user from seeing the old value being replaced upon entering the page, the value is reset when the new page was entered successfully.
    // If the new page can't be entered the old value will stay the same.
    this.searchbarValue = "";

    if (this.updateComponentListSubscription) {
      this.updateComponentListSubscription.unsubscribe();
    }
  }

  /**
   * Updates the list of components that is displayed.
   * @param config The new configuration of the edge.
   */
  updateComponentsList(config: EdgeConfig) {
    this.config = config;
    const categorizedComponentIds: string[] = [];
    this.list = config.listActiveComponents(categorizedComponentIds);
    for (const entry of this.list) {
      entry.isNatureClicked = false;
      entry.filteredComponents = entry.components;
    }
  }

  updateFilter(completeFilter: string) {
    // take each space-separated string as an individual and-combined filter
    const filters = completeFilter.toLowerCase().split(" ");
    let countFilteredEntries = 0;
    for (const entry of this.list) {
      entry.filteredComponents = entry.components.filter(entry =>
        // Search for filter strings in Component-ID, -Alias and Factory-ID
        Utils.matchAll(filters, [
          entry.id.toLowerCase(),
          entry.alias.toLowerCase(),
          entry.factoryId,
        ]),
      );
      countFilteredEntries += entry.filteredComponents.length;
    }
    // If not more than 5 Entries survived filtering -> show all of them immediately
    if (countFilteredEntries > 5) {
      this.showAllEntries = false;
    } else {
      this.showAllEntries = true;
    }
  }
}
